import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const postMalUrl = async (userId, url) => {
	try {
		const token = sessionStorage.getItem('authToken');
		const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/malware/scanUrl`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${token}`
			},
			body: JSON.stringify({ url })
		});
		
		if (!response.ok) {
			const errorResponse = await response.text();  // Read the error message
			console.error('Error response:', errorResponse);
			throw new Error(`Failed to fetch user URL: ${errorResponse}`);
		}    
		return response.json();
	} catch (error) {
		console.error('Error posting user URL:', error);
		throw error;
	}
};

export const postMalFile = async (userId, file) => {
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw new Error('Authorization token is missing. Please log in again.');
    }
    
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/malware/scanFile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text(); // Get the error message
      console.error('Error response:', errorText);
      throw new Error(`Failed to upload file: ${response.status} - ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error posting file:', error.message || error);
    throw error;
  }
};

export const postMalSearch = async (userId, search) => {
  try {
    const token = sessionStorage.getItem('authToken'); // Retrieve auth token
    if (!token) {
      throw new Error('Authorization token is missing. Please log in again.');
    }
    
    // Prepare FormData
    const formData = new FormData();
    formData.append('search', search);

    // Send POST request
    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/malware/scanSearch`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`, // Add Authorization token
      },
      body: formData, // Attach FormData with the file
    });

    // Check if the response is not OK
    if (!response.ok) {
      const errorText = await response.text(); // Get the error message
      console.error('Error response:', errorText);
      throw new Error(`Failed to upload file: ${response.status} - ${errorText}`);
    }

    // Parse and return the response JSON
    return await response.json();
  } catch (error) {
    console.error('Error posting file:', error.message || error);
    throw error; // Re-throw the error for the caller to handle
  }
};